import validationSchema from './Schema';

export default validationSchema;



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/validation/index.js